export default "/aizhushou.0f7b888f-d5bf4e.jpg";